(function(app, ng) {

    app.directive("yearCalendar",
        [
            function() {
                return {
                    restrict: "A",
                    scope: {
                        options: "&",
                        ngModel: "="
                    },
                    link: function (scope, elem) {
                        var defaults = {
                            enableContextMenu: true,
                            dataSource: scope.ngModel
                        }

                        scope.$watch("ngModel",
                            function(newVal) {
                                if (!newVal) return false;

                                $(elem).data("calendar").setDataSource(newVal);
                            });

                        scope.$watch(function() {
                                return scope.options();
                            },
                            function(newVal) {
                                if (!newVal) return false;

                                if (newVal.minDate) $(elem).data("calendar").setMinDate(newVal.minDate);
                                if (newVal.maxDate) $(elem).data("calendar").setMaxDate(newVal.maxDate);

                                $(elem).data("calendar").setYear(newVal.minDate.getFullYear());
                            }, true);

                        $(elem).calendar(ng.extend(defaults, scope.options()));
                    }
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line